import { MSG_TYPE_MODAL_DIALOG_CLOSE } from 'ui-addon-iframeable/messaging/IFrameMessageTypes';
// @ts-ignore untyped dependency
import { openHelpWidget } from '../../utils/zorse';
// @ts-ignore untyped dependency
import { useEmbedContext } from '../../hooks/useEmbedContext';
// @ts-ignore untyped dependency
import { getPortalScopes } from '../../actions/AuthActions';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import { useQuery } from 'data-fetching-client';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Banner } from 'foundations-components/transitional/components/Banner';
import { BreakString } from 'foundations-components/transitional/components/BreakString';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { H3 } from 'foundations-components/transitional/components/H3';
import { HR } from 'foundations-components/transitional/components/HR';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Image } from 'foundations-components/transitional/components/Image';
import { IntersectionObserver } from 'foundations-components/transitional/components/IntersectionObserver';
import { Link } from 'foundations-components/transitional/components/Link';
import { List } from 'foundations-components/transitional/components/List';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { Media } from 'foundations-components/transitional/components/Media';
import { MediaBody } from 'foundations-components/transitional/components/MediaBody';
import { MediaRight } from 'foundations-components/transitional/components/MediaRight';
import { Section as FoundationsSection } from 'foundations-components/transitional/components/Section';
import { Small } from 'foundations-components/transitional/components/Small';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import AssetContactInfo from 'marketplace-ui-assets-core/details/components/AssetContactInfo';
import AssetProviderProfile from 'marketplace-ui-assets-core/details/components/AssetProviderProfile';
import AssetResources from 'marketplace-ui-assets-core/details/components/AssetResources';
import AssetSupport from 'marketplace-ui-assets-core/details/components/AssetSupport';
import { getCmsFreeSignupUrl } from 'marketplace-ui-assets-core/utils/urls';
import BigText from 'marketplace-ui-common/components/elements/BigText';
import * as PlanType from 'marketplace-ui-common/constants/pricings/PlanType';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { useScreenSize } from 'marketplace-ui-common/hooks/useScreenSize';
import { ResponsiveInnerSection } from 'marketplace-ui-common/layout/components/InnerSection';
import MainSection from 'marketplace-ui-common/layout/components/MainSection';
import MainSectionInner from 'marketplace-ui-common/layout/components/MainSectionInner';
import { MediaQueryView } from 'marketplace-ui-common/layout/components/MediaQueryView';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { isSucceeded, isUninitialized } from 'marketplace-ui-common/requestStates/RequestStateUtils';
import { getCredentialDisplayName } from 'marketplace-ui-common/utils/credentials';
import { getInstallsBucket } from 'marketplace-ui-common/utils/installs';
import { PlanCompatibilityMessage } from 'marketplace-ui-details/compatibility/PlanCompatibilityMessage';
import { OfferingReviewType } from 'marketplace-ui-reviews/constants';
import Raven from 'raven-js';
import { Fragment, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { useTheme } from 'styled-components';
import RouterFilterTagButton from '../../common/components/RouterFilterTagButton';
import HubsParamsTracker from '../../components/HubsParamsTracker';
import Reviews from '../../components/reviews/Reviews';
import * as AppContext from '../../constants/AppContext';
import * as PortalScope from '../../constants/PortalScope';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
import AssetVersionHistoryModalPanel from '../../details/components/AssetVersionHistoryModalPanel';
import CurrencyText from '../../details/components/CurrencyText';
import MissingScopesMessage from '../../details/components/MissingScopesMessage';
import { useMissingPortalScopes } from '../../hooks/useMissingPortalScopes';
import { PublicOnly, getAppContext } from '../../selectors/app';
import { getHasZorseWebticketScope } from '../../selectors/auth';
import { getAssetEventSelectorId, getModuleEventSelectorId, getThemeEventSelectorId } from '../../utils/hsAnalytics';
import { GET_PROVIDER_CERTIFICATIONS } from '../queries/providerCertificationsQuery';
import AssetDemoButton from './AssetDemoButton';
import AssetDetailsHeader from './AssetDetailsHeader';
import AssetDownloadButton from './AssetDownloadButton';
import AssetFeatures from './AssetFeatures';
import { AssetMediaCarousel } from './AssetMediaCarousel';
import AssetSetupGuideButton from './AssetSetupGuideButton';
import AssetShareButton from './AssetShareButton';
import { FeatureCompatibilityModal } from './FeatureCompatibilityModal';
import AssetDetailsDocumentHead from './documentHead/AssetDetailsDocumentHead';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PORTAL_SCOPES = Object.values(PortalScope);
const MISSING_SCOPES_LINK = 'https://knowledge.hubspot.com/resources/how-to-purchase-a-template';
const CERTIFICATIONS_LEARN_MORE_LINK = 'https://academy.hubspot.com/certification-overview';
const NoopExternalIcon = () => null;
const ExternalLink = props => /*#__PURE__*/_jsx(Link, Object.assign({}, props, {
  ExternalIcon: NoopExternalIcon,
  external: true
}));
const Section = ({
  children,
  label
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx("dt", {
    children: label
  }), /*#__PURE__*/_jsx("dd", {
    children: children
  })]
});
function SignUpCTA({
  button,
  children,
  isMobileView = false
}) {
  return isMobileView ? /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    direction: "column",
    justify: "between",
    wrap: "nowrap",
    children: [children, button]
  }) : /*#__PURE__*/_jsxs(Media, {
    align: "center",
    children: [/*#__PURE__*/_jsx(MediaBody, {
      children: children
    }), /*#__PURE__*/_jsx(MediaRight, {
      children: button
    })]
  });
}
export default function AssetDetailsPage({
  assetContentsRequestState,
  assetDetails,
  assetScopes,
  offeringType,
  renderedAssetContents,
  renderedAssetRecommendationsSection,
  renderedClientExamples,
  renderedExpandableTagsSection,
  use
}) {
  const trellisTheme = useTheme();
  const {
    trackDetailsInteraction,
    trackDetailsPageview
  } = useContext(StorefrontUsageTrackerContext);
  const {
    isEmbedded,
    sendMessage
  } = useEmbedContext();
  const appContext = useSelector(getAppContext);
  const isAdminPreview = appContext === AppContext.ADMIN_PREVIEW;
  const isInApp = appContext === AppContext.IN_APP;
  const isPreview = use === 'preview' || isAdminPreview;
  const lang = getLang();
  const {
    data,
    previousData
  } = useQuery(GET_PROVIDER_CERTIFICATIONS);
  const providerCertifications = useMemo(() => {
    const providerCertificationsData = data || previousData;
    if (!providerCertificationsData || isAdminPreview) {
      return {};
    }
    const mappedCerts = {};
    providerCertificationsData.certifications.results.forEach(cert => {
      mappedCerts[cert.id] = cert;
    });
    return mappedCerts;
  }, [data, isAdminPreview, previousData]);
  const hasZorseWebticketScope = useSelector(getHasZorseWebticketScope);
  const dispatch = useDispatch();
  const [reviewsFulfilled, setReviewsFulfilled] = useState(false);
  const {
    isMobileView
  } = useResponsiveProps({
    isMobileView: {
      [ScreenSizes.XS]: true,
      [ScreenSizes.SM]: false
    }
  });
  const screenSize = useScreenSize();
  const isLGScreenOrGreater = screenSize === 'lg' || screenSize === 'xl';
  const isLGScreenOrLess = screenSize === 'xs' || screenSize === 'sm' || screenSize === 'md' || screenSize === 'lg';
  const [featureCompatibilityModalOpen, setFeatureCompatibilityModalOpen] = useState(false);
  const invalidPortalScopes = useMemo(() => {
    return assetScopes.filter(scope => !PORTAL_SCOPES.includes(scope));
  }, [assetScopes]);
  const [invalidPortalScopesRequestState, setInvalidPortalScopesRequestState] = useState('UNINITIALIZED');
  useEffect(() => {
    if (isSucceeded(assetContentsRequestState) && invalidPortalScopes.length && isUninitialized(invalidPortalScopesRequestState) && isInApp) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setInvalidPortalScopesRequestState('PENDING');
      dispatch(getPortalScopes(invalidPortalScopes)).then(() => {
        setInvalidPortalScopesRequestState('SUCCEEDED');
      }).catch(() => {
        setInvalidPortalScopesRequestState('FAILED');
      });
    }
  }, [assetContentsRequestState, dispatch, invalidPortalScopes, invalidPortalScopesRequestState, isInApp]);
  useEffect(() => {
    if (isSucceeded(assetContentsRequestState) && invalidPortalScopes.length) {
      invalidPortalScopes.forEach(scope => {
        Raven.captureMessage(`Invalid asset scope - ${scope}`, {
          level: 'warning',
          extra: {
            scope
          }
        });
      });
    }
  }, [invalidPortalScopes, assetContentsRequestState]);

  // marketplace-ui-reviews uses a single object that contains all the properties.
  const trackReviewInteraction = useCallback(eventProperties => {
    trackDetailsInteraction(eventProperties.action, Object.assign({}, eventProperties));
  }, [trackDetailsInteraction]);
  const {
    benefits,
    casesUrl,
    chatUrl,
    exampleUrl,
    facebookUrl,
    features,
    forumUrl,
    name,
    offering: {
      installsCount,
      firstPublishedAt,
      portalId: offeringPortalId
    },
    offeringId,
    phone,
    pricing: {
      cents,
      planType
    },
    privacy2Url,
    privacy3Url,
    privacyUrl,
    provider,
    reviewSummary,
    screenshots,
    setupUrl,
    slug,
    support,
    supportEmail,
    supportLanguages,
    supportUrl,
    termsUrl,
    tiers,
    thumbnailUrl,
    versionNumber,
    versionPublishedAt,
    videoUrl
  } = assetDetails;
  const missingPortalScopes = useMissingPortalScopes(assetScopes);
  const signupUrl = getCmsFreeSignupUrl(slug);
  const isFree = planType === PlanType.FREE;
  const installsBucket = getInstallsBucket(installsCount);
  const {
    name: providerName
  } = provider;
  const [versionHistoryOpen, setVersionHistoryOpen] = useState(false);
  const compatibilityType = useMemo(() => {
    if (missingPortalScopes.length) {
      if (isFree) {
        return 'COMPATIBLE_SOME';
      }
      return 'COMPATIBLE_NONE';
    } else {
      return 'COMPATIBLE_ALL';
    }
  }, [isFree, missingPortalScopes]);
  const renderSupportLanguageTag = useCallback(langCode => /*#__PURE__*/_jsx(RouterFilterTagButton, {
    disabled: isPreview,
    onClick: () => trackDetailsInteraction('click filter tag', {
      filter: 'languages',
      value: langCode
    }),
    queryField: "languages",
    value: langCode,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `SharedI18nStrings.languageNames.${langCode}`
    })
  }, `supported-language-${langCode}`), [isPreview, trackDetailsInteraction]);
  const renderedCertifications = useMemo(() => {
    if (assetDetails.provider.credentials.length) {
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(Flex, {
          alignItems: "start",
          "aria-label": unescapedText(`marketplace-assets-ui.details.certificationsAriaLabel`),
          as: "ul",
          marginBlockStart: "200",
          marginBlockEnd: "0",
          paddingInlineStart: "0",
          flexDirection: "row",
          justifyContent: "start",
          flexWrap: "wrap",
          children: assetDetails.provider.credentials.map(credentialId => {
            const certificationData = providerCertifications[credentialId];
            if (certificationData) {
              const certificationDisplayName = getCredentialDisplayName(certificationData, lang);
              return (
                /*#__PURE__*/
                /* eslint-disable-next-line react/jsx-key */
                _jsx("li", {
                  style: {
                    listStyle: 'none'
                  },
                  children: /*#__PURE__*/_jsx(Tooltip, {
                    title: certificationDisplayName,
                    children: /*#__PURE__*/_jsx(Image, {
                      alt: certificationDisplayName,
                      marginInlineEnd: "100",
                      marginBlockEnd: "100",
                      blockSize: "28px",
                      inlineSize: "28px",
                      src: certificationData.icon
                    })
                  }, credentialId)
                })
              );
            }
            return null;
          })
        }), /*#__PURE__*/_jsx(Link, {
          "aria-label": unescapedText('marketplace-assets-ui.details.providerInfo.ariaLabel'),
          external: true,
          href: CERTIFICATIONS_LEARN_MORE_LINK,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.details.providerInfo.learnMore"
          })
        })]
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.details.providerInfo.noCertifications"
    });
  }, [assetDetails, providerCertifications, lang]);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "ASSET_DETAILS_LOAD",
    children: [/*#__PURE__*/_jsx(AssetDetailsDocumentHead, {
      assetDetails: assetDetails,
      offeringType: offeringType,
      ready: reviewsFulfilled
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        position: 'relative'
      },
      children: [isEmbedded && /*#__PURE__*/_jsx(DialogCloseButton, {
        color: "icon-tertiary-default",
        "data-test-id": "asset-details-close-button",
        onClick: () => sendMessage(MSG_TYPE_MODAL_DIALOG_CLOSE)
      }), /*#__PURE__*/_jsxs(ListingPage, {
        contentAreaFlush: true,
        headerComponent: /*#__PURE__*/_jsx(MainSectionInner, {
          children: /*#__PURE__*/_jsx(AssetDetailsHeader, {
            assetDetails: assetDetails,
            assetScopes: assetScopes,
            exampleUrl: exampleUrl,
            isEmbedded: isEmbedded,
            isPreview: isPreview,
            name: name,
            offeringType: offeringType,
            onTrackInteraction: trackDetailsInteraction,
            onTrackPageview: trackDetailsPageview,
            providerName: providerName,
            reviewSummary: reviewSummary
          })
        }),
        mainSectionBackgroundColor: trellisTheme.color['fill-surface-default'],
        pageBackgroundColor: trellisTheme.color['fill-surface-default'],
        pageLayout: "full-width",
        children: [/*#__PURE__*/_jsx(MainSection, {
          responsive: true,
          color: "light",
          children: /*#__PURE__*/_jsx(MainSectionInner, {
            children: /*#__PURE__*/_jsxs(Grid, {
              children: [/*#__PURE__*/_jsxs(GridItem, {
                paddingInlineEnd: screenSize === 'md' ? '1000' : isLGScreenOrGreater ? '1300' : undefined,
                size: {
                  xs: 12,
                  md: 8
                },
                children: [isInApp && missingPortalScopes.length && (!invalidPortalScopes.length || isSucceeded(invalidPortalScopesRequestState)) ? /*#__PURE__*/_jsx(ResponsiveInnerSection, {
                  children: /*#__PURE__*/_jsx(Alert, {
                    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "marketplace-assets-ui.details.missingScopesAlert.title",
                      options: {
                        offeringType: unescapedText(`marketplace-assets-ui.details.offeringType.${offeringType}_lowercase`)
                      }
                    }),
                    type: "warning",
                    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                      message: "marketplace-assets-ui.details.missingScopesAlert.message_jsx",
                      elements: {
                        Link: ExternalLink
                      },
                      options: {
                        href: MISSING_SCOPES_LINK
                      }
                    })
                  })
                }) : null, /*#__PURE__*/_jsx(PublicOnly, {
                  children: /*#__PURE__*/_jsx(Banner, {
                    children: /*#__PURE__*/_jsx(SignUpCTA, {
                      button: /*#__PURE__*/_jsx(Button, {
                        marginBlockStart: isMobileView ? '200' : undefined,
                        "data-test-id": "asset-details-signup-banner-button",
                        href: signupUrl,
                        onClick: () => trackDetailsInteraction('click cms sign up link'),
                        size: "extra-small",
                        use: "primary-white",
                        children: /*#__PURE__*/_jsx(FormattedMessage, {
                          message: "marketplace-assets-ui.details.signUpBanner.signUp"
                        })
                      }),
                      isMobileView: isMobileView,
                      children: /*#__PURE__*/_jsx("b", {
                        children: isFree ? /*#__PURE__*/_jsx(FormattedMessage, {
                          message: "marketplace-assets-ui.details.signUpBanner.freeTitle",
                          options: {
                            offeringType: unescapedText(`marketplace-assets-ui.details.offeringType.${offeringType}`)
                          }
                        }) : /*#__PURE__*/_jsx(FormattedMessage, {
                          message: "marketplace-assets-ui.details.signUpBanner.paidTitle",
                          options: {
                            offeringType: unescapedText(`marketplace-assets-ui.details.offeringType.${offeringType}`)
                          }
                        })
                      })
                    })
                  })
                }), /*#__PURE__*/_jsx(ResponsiveInnerSection, {
                  children: /*#__PURE__*/_jsx(AssetMediaCarousel, {
                    screenshots: screenshots,
                    videoUrl: videoUrl,
                    onTrackInteraction: trackDetailsInteraction
                  })
                }), /*#__PURE__*/_jsxs(ResponsiveInnerSection, {
                  id: "overview",
                  children: [/*#__PURE__*/_jsx(H3, {
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "marketplace-assets-ui.details.overview.title"
                    })
                  }), /*#__PURE__*/_jsx(ExpandableText, {
                    buttonAlign: "left",
                    maxHeight: 400,
                    children: /*#__PURE__*/_jsx(BreakString, {
                      children: /*#__PURE__*/_jsx(BigText, {
                        children: /*#__PURE__*/_jsx(SanitizedText, {
                          body: benefits
                        })
                      })
                    })
                  })]
                }), /*#__PURE__*/_jsxs(ResponsiveInnerSection, {
                  id: "features",
                  children: [/*#__PURE__*/_jsx(H3, {
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "marketplace-assets-ui.details.features.title"
                    })
                  }), /*#__PURE__*/_jsx(BigText, {
                    children: /*#__PURE__*/_jsx(AssetFeatures, {
                      features: features,
                      onTrackInteraction: trackDetailsInteraction
                    })
                  })]
                }), renderedAssetContents]
              }), /*#__PURE__*/_jsxs(GridItem, {
                size: {
                  xs: 12,
                  md: 4
                },
                children: [/*#__PURE__*/_jsx(MediaQueryView, {
                  min: "md",
                  children: /*#__PURE__*/_jsx(ResponsiveInnerSection, {
                    children: /*#__PURE__*/_jsxs(CardWrapper, {
                      marginBlockEnd: "0",
                      marginBlockStart: "-1700",
                      padding: "500",
                      paddingBlockEnd: "600",
                      compact: true,
                      "data-test-id": "asset-actions-card",
                      children: [/*#__PURE__*/_jsx(CardSection, {
                        textAlign: "center",
                        children: /*#__PURE__*/_jsx(Text, {
                          typography: "heading-600",
                          children: isFree ? /*#__PURE__*/_jsx(FormattedMessage, {
                            message: "marketplace-assets-ui.details.downloadCard.free"
                          }) : /*#__PURE__*/_jsx(CurrencyText, {
                            cents: cents
                          })
                        })
                      }), /*#__PURE__*/_jsx(CardSection, {
                        children: /*#__PURE__*/_jsxs(TFlex, {
                          direction: "column",
                          align: "stretch",
                          children: [/*#__PURE__*/_jsx(AssetDownloadButton, {
                            marginBlockEnd: "300",
                            assetDetails: assetDetails,
                            assetScopes: assetScopes,
                            "data-test-id": "asset-download-button",
                            offeringType: offeringType,
                            section: "header"
                          }), /*#__PURE__*/_jsx(AssetDemoButton, {
                            marginInlineStart: "0",
                            exampleUrl: exampleUrl,
                            name: name,
                            onTrackInteraction: trackDetailsInteraction,
                            onTrackPageview: trackDetailsPageview,
                            modalPrimaryButton: /*#__PURE__*/_jsx(AssetDownloadButton, {
                              assetDetails: assetDetails,
                              assetScopes: assetScopes,
                              offeringType: offeringType
                            }),
                            providerName: providerName,
                            section: "header"
                          })]
                        })
                      }), /*#__PURE__*/_jsxs(CardSection, {
                        textAlign: "center",
                        children: [/*#__PURE__*/_jsx(View, {
                          as: "span",
                          blockSize: "auto",
                          children: /*#__PURE__*/_jsx(AssetSetupGuideButton, {
                            offeringType: offeringType,
                            setupUrl: setupUrl
                          })
                        }), /*#__PURE__*/_jsx(AssetShareButton, {
                          section: "header",
                          use: "link"
                        })]
                      })]
                    })
                  })
                }), /*#__PURE__*/_jsx(ResponsiveInnerSection, {
                  children: /*#__PURE__*/_jsxs(View, {
                    paddingInline: isLGScreenOrLess ? '400' : screenSize === 'xl' ? '800' : undefined,
                    children: [/*#__PURE__*/_jsxs(ResponsiveInnerSection, {
                      children: [/*#__PURE__*/_jsx(H3, {
                        children: /*#__PURE__*/_jsx(FormattedMessage, {
                          message: "marketplace-assets-ui.details.assetInfo.title",
                          options: {
                            offeringType: unescapedText(`marketplace-assets-ui.details.offeringType.${offeringType}`)
                          }
                        })
                      }), /*#__PURE__*/_jsxs(DescriptionList, {
                        children: [/*#__PURE__*/_jsx("dt", {
                          children: /*#__PURE__*/_jsx(FormattedMessage, {
                            message: "marketplace-assets-ui.details.assetInfo.installs"
                          })
                        }), /*#__PURE__*/_jsx("dd", {
                          children: installsBucket > 0 ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
                            message: "marketplace-assets-ui.details.assetInfo.installsBucket.bucket_jsx",
                            elements: {
                              Number: FormattedNumber
                            },
                            options: {
                              value: installsBucket
                            }
                          }) : /*#__PURE__*/_jsx(FormattedMessage, {
                            message: "marketplace-assets-ui.details.assetInfo.installsBucket.min"
                          })
                        }), /*#__PURE__*/_jsx("dt", {
                          children: /*#__PURE__*/_jsx(FormattedMessage, {
                            message: "marketplace-assets-ui.details.assetInfo.created"
                          })
                        }), /*#__PURE__*/_jsx("dd", {
                          children: firstPublishedAt != null ? /*#__PURE__*/_jsx(FormattedDateTime, {
                            value: firstPublishedAt,
                            format: "ll"
                          }) : /*#__PURE__*/_jsx("span", {
                            children: "\u2014"
                          })
                        }), /*#__PURE__*/_jsx("dt", {
                          children: /*#__PURE__*/_jsx(FormattedMessage, {
                            message: "marketplace-assets-ui.details.assetInfo.version",
                            options: {
                              versionNumber
                            }
                          })
                        }), /*#__PURE__*/_jsx("dd", {
                          children: /*#__PURE__*/_jsxs(List, {
                            wrapChildren: true,
                            children: [/*#__PURE__*/_jsx("span", {
                              children: /*#__PURE__*/_jsx(FormattedDateTime, {
                                value: versionPublishedAt,
                                format: "ll"
                              })
                            }), /*#__PURE__*/_jsx("span", {
                              children: /*#__PURE__*/_jsx(Button, {
                                use: "link",
                                onClick: () => {
                                  setVersionHistoryOpen(true);
                                  trackDetailsInteraction('click version history link', {
                                    section: 'sidebar about'
                                  });
                                },
                                children: /*#__PURE__*/_jsx(FormattedMessage, {
                                  message: "marketplace-assets-ui.details.assetInfo.versionHistory"
                                })
                              })
                            })]
                          })
                        }), renderedExpandableTagsSection]
                      })]
                    }), /*#__PURE__*/_jsxs(ResponsiveInnerSection, {
                      children: [/*#__PURE__*/_jsx(H3, {
                        children: /*#__PURE__*/_jsx(FormattedMessage, {
                          message: "marketplace-assets-ui.details.requirements.title"
                        })
                      }), /*#__PURE__*/_jsx(FoundationsSection, {
                        children: /*#__PURE__*/_jsx(DescriptionList, {
                          children: /*#__PURE__*/_jsx(Section, {
                            label: /*#__PURE__*/_jsx(FormattedMessage, {
                              message: 'marketplace-assets-ui.details.requirements.compatibilityHeadingText'
                            }),
                            children: tiers.includes('HUBSPOT_FREE') && !assetScopes.length ? /*#__PURE__*/_jsx(FormattedMessage, {
                              message: "detailsPage.compatibility.plans.allPlans"
                            }) : /*#__PURE__*/_jsx(PlanCompatibilityMessage, {
                              appContext: isInApp ? 'app' : 'public',
                              compatibilityType: compatibilityType,
                              helpText: compatibilityType !== 'COMPATIBLE_ALL' ? /*#__PURE__*/_jsx(HelpIcon, {
                                title: /*#__PURE__*/_jsx(MissingScopesMessage, {
                                  missingPortalScopes: missingPortalScopes,
                                  offeringType: offeringType
                                })
                              }) : undefined,
                              onCompatibilityModalOpen: () => setFeatureCompatibilityModalOpen(true)
                            })
                          })
                        })
                      })]
                    }), /*#__PURE__*/_jsxs(ResponsiveInnerSection, {
                      children: [/*#__PURE__*/_jsx(H3, {
                        children: /*#__PURE__*/_jsx(FormattedMessage, {
                          message: "marketplace-assets-ui.details.providerInfo.title",
                          options: {
                            providerName
                          }
                        })
                      }), /*#__PURE__*/_jsx(FoundationsSection, {
                        children: /*#__PURE__*/_jsx(AssetProviderProfile, {
                          onTrackInteraction: (action, eventProperties = {}) => {
                            trackDetailsInteraction(action, Object.assign({}, eventProperties, {
                              section: 'sidebar provider'
                            }));
                          },
                          providerWebsiteAnalyticsId: getAssetEventSelectorId('SIDEBAR-PROVIDER-WEBSITE', offeringType),
                          provider: provider,
                          use: "sidebar"
                        })
                      }), /*#__PURE__*/_jsxs(DescriptionList, {
                        children: [/*#__PURE__*/_jsx("dt", {
                          children: /*#__PURE__*/_jsx(FormattedMessage, {
                            message: "marketplace-assets-ui.details.providerInfo.certifications"
                          })
                        }), /*#__PURE__*/_jsx("dd", {
                          children: renderedCertifications
                        })]
                      })]
                    }), /*#__PURE__*/_jsx(ResponsiveInnerSection, {
                      children: /*#__PURE__*/_jsx(AssetResources, {
                        casesUrl: casesUrl,
                        forumUrl: forumUrl,
                        getAssetEventSelectorId: offeringType === 'THEME' ? getThemeEventSelectorId : getModuleEventSelectorId,
                        offeringType: offeringType,
                        onTrackInteraction: action => trackDetailsInteraction(action, {
                          section: 'sidebar resources'
                        }),
                        setupUrl: setupUrl,
                        supportUrl: supportUrl
                      })
                    }), /*#__PURE__*/_jsx(ResponsiveInnerSection, {
                      children: /*#__PURE__*/_jsx(AssetContactInfo, {
                        chatUrl: chatUrl,
                        facebookUrl: facebookUrl,
                        getAssetEventSelectorId: offeringType === 'THEME' ? getThemeEventSelectorId : getModuleEventSelectorId,
                        onTrackInteraction: action => trackDetailsInteraction(action, {
                          section: 'sidebar contact'
                        }),
                        phone: phone,
                        provider: provider,
                        supportEmail: supportEmail
                      })
                    }), /*#__PURE__*/_jsxs(ResponsiveInnerSection, {
                      children: [/*#__PURE__*/_jsx(H3, {
                        children: /*#__PURE__*/_jsx(FormattedMessage, {
                          message: "marketplace-assets-ui.details.termsOfService.title"
                        })
                      }), /*#__PURE__*/_jsx("p", {
                        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                          message: "marketplace-assets-ui.details.termsOfService.message_jsx",
                          elements: {
                            Link: ExternalLink
                          },
                          options: {
                            privacyPolicyLink: {
                              href: privacyUrl,
                              onClick: () => trackDetailsInteraction('click privacy policy link', {
                                section: 'sidebar terms'
                              })
                            },
                            termsLink: {
                              href: termsUrl,
                              onClick: () => trackDetailsInteraction('click terms link', {
                                section: 'sidebar terms'
                              })
                            }
                          }
                        })
                      }), privacy2Url || privacy3Url ? /*#__PURE__*/_jsxs(Fragment, {
                        children: [/*#__PURE__*/_jsx(Small, {
                          children: /*#__PURE__*/_jsx(FormattedMessage, {
                            message: "marketplace-assets-ui.details.termsOfService.otherPrivacyInformation"
                          })
                        }), /*#__PURE__*/_jsx(List, {
                          wrapChildren: true,
                          children: [privacy2Url, privacy3Url].map((otherPrivacyUrl, index) => otherPrivacyUrl ? /*#__PURE__*/_jsx(ExternalLink, {
                            href: otherPrivacyUrl,
                            onClick: () => trackDetailsInteraction('click other privacy policy link', {
                              section: 'sidebar terms'
                            }),
                            children: /*#__PURE__*/_jsx(TruncateString, {
                              children: otherPrivacyUrl
                            })
                          }, `privacy-link-${index}`) : null)
                        })]
                      }) : null]
                    }), hasZorseWebticketScope && /*#__PURE__*/_jsxs(Fragment, {
                      children: [/*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx("p", {
                        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                          message: "marketplace-assets-ui.details.report.message_jsx",
                          options: {
                            offeringType: unescapedText(`marketplace-assets-ui.details.offeringType.${offeringType}`),
                            onClick: () => {
                              trackDetailsInteraction('click report this asset link', {
                                section: 'sidebar terms'
                              });
                              openHelpWidget({
                                create: true
                              });
                            }
                          },
                          elements: {
                            Link
                          }
                        })
                      })]
                    })]
                  })
                })]
              })]
            })
          })
        }), renderedClientExamples, /*#__PURE__*/_jsx(MainSection, {
          id: "support",
          responsive: true,
          children: /*#__PURE__*/_jsx(MainSectionInner, {
            children: /*#__PURE__*/_jsxs(Grid, {
              children: [/*#__PURE__*/_jsxs(GridItem, {
                size: {
                  xs: 12,
                  xl: 8
                },
                children: [/*#__PURE__*/_jsx(Text, {
                  marginBlockEnd: "400",
                  as: "h3",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "marketplace-assets-ui.details.support.title"
                  })
                }), /*#__PURE__*/_jsx(AssetSupport, {
                  chatUrl: chatUrl,
                  facebookUrl: facebookUrl,
                  getAssetEventSelectorId: offeringType === 'THEME' ? getThemeEventSelectorId : getModuleEventSelectorId,
                  languageTagRenderer: renderSupportLanguageTag,
                  onTrackInteraction: trackDetailsInteraction,
                  phone: phone,
                  provider: provider,
                  responsive: true,
                  support: support,
                  supportEmail: supportEmail,
                  supportLanguages: supportLanguages,
                  supportUrl: supportUrl
                })]
              }), /*#__PURE__*/_jsx(GridItem, {
                size: {
                  xs: 12,
                  xl: 4
                }
              })]
            })
          })
        }), !isAdminPreview && /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(MainSection, {
            id: "reviews",
            responsive: true,
            children: /*#__PURE__*/_jsx(MainSectionInner, {
              children: /*#__PURE__*/_jsx(Reviews, {
                name: name,
                exampleUrl: exampleUrl,
                isPreview: isPreview,
                offeringId: offeringId,
                offeringPortalId: offeringPortalId,
                offeringType: offeringType,
                onTrackInteraction: trackReviewInteraction,
                providerName: providerName,
                onReviewsFulfilled: setReviewsFulfilled,
                reviewType: OfferingReviewType[offeringType],
                supportUrl: supportUrl,
                thumbnailUrl: thumbnailUrl,
                versionNumber: versionNumber
              })
            })
          }), /*#__PURE__*/_jsx(IntersectionObserver, {
            onIntersectionChange: ({
              entries,
              observer
            }) => {
              if (entries[0].isIntersecting) {
                observer.disconnect();
              }
            },
            renderContent: isIntersecting => {
              if (isIntersecting && !isEmbedded) {
                return renderedAssetRecommendationsSection;
              }
              return /*#__PURE__*/_jsx("div", {
                "data-test-id": "load-recommendations"
              });
            }
          })]
        })]
      })]
    }), featureCompatibilityModalOpen && /*#__PURE__*/_jsx(FeatureCompatibilityModal, {
      appContext: isInApp ? 'app' : 'public',
      onClose: () => setFeatureCompatibilityModalOpen(false),
      assetScopes: assetScopes,
      offeringType: offeringType,
      trackInteraction: trackDetailsInteraction
    }), versionHistoryOpen && /*#__PURE__*/_jsx(AssetVersionHistoryModalPanel, {
      offeringId: offeringId,
      onClose: () => setVersionHistoryOpen(false),
      onTrackInteraction: trackDetailsInteraction,
      onTrackPageview: trackDetailsPageview
    }), /*#__PURE__*/_jsx(HubsParamsTracker, {}, `asset-details-${slug}`)]
  });
}